// import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "components/DashboardNavbar";

import { create, updateById } from "services/Articles";
import { useNavigate, useParams } from "react-router-dom";
import { useMaterialUIController, setErrorSB, setSuccessSB } from "context";
import { Formik } from "formik";
import * as Yup from "yup";
import compressImage from "util/compress";
import useLocale from "context/useLocale";
import ArticleFormik from "./form";

function ArticleForm() {
  const locale = useLocale();
  const { id } = useParams();
  const [, dispatch] = useMaterialUIController();
  const navigate = useNavigate();

  const submitForm = async (values) => {
    const form = new FormData();
    form.append("title_ar", values.titleAr);
    form.append("title_en", values.titleEn);
    form.append("topic_ar", values.topicAr);
    form.append("topic_en", values.topicEn);
    if (values.image instanceof File) {
      const compressed = await compressImage(values.image);
      form.append("image", compressed, values.image.name);
    } else {
      form.append("image", values.image);
    }
    if (id) {
      updateById(id, form).then(
        (res) => {
          setSuccessSB(dispatch, `${res.data.data.title.en} article has been updated`);
          setTimeout(() => {
            navigate("/dashboard/article/");
          }, 500);
        },
        (err) =>
          setErrorSB(
            dispatch,
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          )
      );
    } else {
      create(form).then(
        (res) => {
          setSuccessSB(dispatch, `${res.data.data.title.en} article has been created`);
          setTimeout(() => {
            navigate("/dashboard/article/");
          }, 1500);
        },
        (err) =>
          setErrorSB(
            dispatch,
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          )
      );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {locale("articlesForm")}
                </MDTypography>
              </MDBox>
              <MDBox p={4}>
                <Formik
                  initialValues={{ titleEn: "", titleAr: "", topicEn: "", topicAr: "", image: "" }}
                  onSubmit={async (values) => {
                    await submitForm(values);
                  }}
                  validationSchema={Yup.object().shape({
                    titleEn: Yup.string().required("Field is required"),
                    titleAr: Yup.string().required("Field is required"),
                    topicEn: Yup.string().required("Field is required"),
                    topicAr: Yup.string().required("Field is required"),
                    image: Yup.mixed().required("Field is required"),
                  })}
                >
                  <ArticleFormik />
                </Formik>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ArticleForm;
